/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function SoftSkillsIcon({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon-soft-skills">
        <g id="Group 82">
          <g id="Group 80 Copy 2">
            <g id="Group 79 Copy 2">
              <g id="Group 78">
                <g id="Group 76 Copy 2">
                  <g id="Group 74 Copy 2">
                    <g id="Group 72 Copy 2">
                      <g id="Group 70 Copy 2">
                        <g id="Group 68 Copy 2">
                          <g id="Group 66 Copy 2">
                            <g id="Group 65 Copy 2">
                              <g id="Group 63 Copy 2">
                                <g id="Group 61 Copy 2">
                                  <g id="Group 59 Copy 3">
                                    <g id="icon-legal and finance copy">
                                      <g id="Group 58 Copy 2">
                                        <g id="icon-journey-course">
                                          <circle
                                            id="Oval"
                                            cx="78.5"
                                            cy="78.5"
                                            r="77.5"
                                            fill={mainColor}
                                            stroke="white"
                                            stroke-width="2"
                                          />
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g id="like copy">
            <path
              id="Path"
              d="M52.3333 61H41.6667C40.2003 61 39 62.1644 39 63.5999V110.4C39 111.835 40.195 113 41.6667 113H52.3333C53.805 113 55 111.835 55 110.4V63.5999C55 62.1644 53.7995 61 52.3333 61Z"
              fill={secondaryColor}
            />
            <path
              id="Path_2"
              d="M112.491 59.3267C112.071 59.256 92.4111 59.3267 92.4111 59.3267L95.1571 51.8759C97.0519 46.7298 95.8251 38.8724 90.5678 36.079C88.856 35.1693 86.4643 34.7125 84.5361 35.1952C83.4302 35.472 82.4584 36.2001 81.8791 37.1757C81.2129 38.2977 81.2817 39.6074 81.0445 40.8515C80.4429 44.007 78.9437 47.0072 76.6221 49.2591C72.5743 53.1854 60 64.5125 60 64.5125V106H103.453C109.316 106.003 113.158 99.4914 110.267 94.4047C113.714 92.209 114.893 87.584 112.874 84.0329C116.321 81.8372 117.5 77.2122 115.481 73.6611C121.429 69.8726 119.44 60.4957 112.491 59.3267Z"
              fill={secondaryColor}
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
SoftSkillsIcon.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
SoftSkillsIcon.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};
const memoized = React.memo(SoftSkillsIcon);
memoized.displayName = 'SoftSkillsIcon';
export default memoized;
